import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/components/layout/layout'
import login from '@/components/login/login'
import wechatbindaccount from '@/components/login/wechatbindaccount'
import getroleandlogin from '@/components/login/getroleandlogin'
import browserprompt from '@/components/login/browserprompt'

import productdetail from '@/components/combo/productdetail'
import product_ssdetail from '@/components/combo/product_ssdetail'
import productpreorder from '@/components/combo/productpreorder'

import oldproductpreorder from '@/components/combo/oldproductpreorder'
import orderdetail from '@/components/order/orderdetail'
import orderdetaildisview from '@/components/order/orderdetaildisview'
import rollcodedetail from '@/components/order/rollcodedetail'

import myset from '@/components/my/myset'
import mydisposter from '@/components/my/mydisposter'
import setlist from '@/components/set/setlist'
import setlock from '@/components/set/setlock'
import setnews from '@/components/set/setnews'
import messageset from '@/components/set/messageset'
import passwordset from '@/components/set/passwordset'
import mypurse from '@/components/mypurse/mypurse'
import immediatewithdrawal from '@/components/mypurse/immediatewithdrawal'
import withdrawalsrecord from '@/components/mypurse/withdrawalsrecord'
import messagedetail from '@/components/message/messagedetail'
import mdisreg from '@/components/regmdiss/mdisreg'

import myclient from '@/components/mydisinfo/myclient'
import myteam from '@/components/mydisinfo/myteam'
import draw from '@/components/my/draw'
import fun from '@/components/fun/fun'
import regthirddissuccess from '@/components/fun/regthirddissuccess'
import showtitle from '@/components/showtitle/showtitle'
import coupon from '@/components/my/coupon'
import specialevent from '@/components/specialevent/specialevent'
import nospecialevent from '@/components/specialevent/nospecialevent'
import fissionactivity from '@/components/fissionactivity/fissionactivity'
import fissionactivitysuccess from '@/components/fissionactivity/fissionactivitysuccess'
import activitycompletion from '@/components/fissionactivity/activitycompletion'
import activityends from '@/components/fissionactivity/activityends'

import weeklynewproduct from '@/components/weeklynewproduct/weeklynewproduct'
import mustpushtoday from '@/components/mustpushtoday/mustpushtoday'


import deliveryaddress from '@/components/deliveryaddress/deliveryaddress'
import deliveryaddressedit from '@/components/deliveryaddress/deliveryaddressedit'
import deliveryaddressadd from '@/components/deliveryaddress/deliveryaddressadd'

import applyrefound from '@/components/order/applyrefound'
import viewlogistics from '@/components/order/viewlogistics'
import logisticlist from '@/components/order/logisticlist'
import disorder from '@/components/disorder/disorder'

import sort from '@/components/sort/sort'

import deliverygoods from '@/components/crab/deliverygoods'
import editdeliveryInfo from '@/components/crab/editdeliveryInfo'
import logistics from '@/components/crab/logistics'
import logisticsdetail from '@/components/crab/logisticsdetail'
import deliveryfinish from '@/components/crab/deliveryfinish'

import yeardeliverygoods from '@/components/yearcard/deliverygoods'
import yeareditdeliveryInfo from '@/components/yearcard/editdeliveryInfo'
import yearlogistics from '@/components/yearcard/logistics'
import yearlogisticsdetail from '@/components/yearcard/logisticsdetail'
import yeardeliveryfinish from '@/components/yearcard/deliveryfinish'


Vue.use(Router)
const account = { template: '<router-view></router-view>' };
export default new Router({
        routes: [{
                path: '/',
                name: 'home',
                redirect:'/app/home'
            },
            { //登陆
                path: '/account',
                name: 'account',
                component: account,
                children: [
                    { path: '/account/login', component: login },
                    { path: '/account/wechatbindaccount', component: wechatbindaccount },
                    { path: '/account/getroleandlogin', component: getroleandlogin }
                ]
            },
            { //布局页面
                path: '/',
                name: 'app',
                component: layout,
                children: [
                    //{path:'/app/home',component:home},//首页
                    // {path:'/app/fun',component:fun},//套餐
                    // {path:'/app/order',component:order},//订单
                    // {path:'/app/us',component:us},//我的
                    { meta: {keepAlive: true},name: 'home',path: '/app/home', component: resolve => require(['@/components/home/home'], resolve) }, //首页
                    { path: '/app/saleactive', component: resolve => require(['@/components/saleactive/saleactive'], resolve)  }, //分类
                    { path: '/app/sort', component: resolve => require(['@/components/sort/sort'], resolve)  }, //分类
                    { path: '/app/fun', component: resolve => require(['@/components/fun/fun'], resolve)  }, //玩赚
                    { path: '/app/order', component: resolve => require(['@/components/order/order'], resolve)  }, //订单
                    { path: '/app/my', component: resolve => require(['@/components/my/my'], resolve)  }, //我的
                    { path: '/app/blank', component: resolve => require(['@/components/blank/blank'], resolve)  }, //空白
                    { path: '/page/specialevent', component: resolve => require(['@/components/specialevent/specialevent'], resolve)  }, //分类
                    { path: '/page/nospecialevent', component: resolve => require(['@/components/specialevent/nospecialevent'], resolve)  }, //分类
                    { meta: {keepAlive: true},name: 'mustpushtoday',path: '/page/mustpushtoday', component: resolve => require(['@/components/mustpushtoday/mustpushtoday'], resolve) }, //空白


                ]
            },
            { //无底部导航页面
                path: '/',
                name: 'page',
                component: account,
                children: [
                    { path: '/page/setlist', component: setlist }, //设置
                    { path: '/page/setlock', component: setlock }, //微信解绑
                    { path: '/page/setnews', component: setnews }, //消息设置
                    { path: '/page/mypurse', component: mypurse  }, //我的钱包
                    { path: '/page/messageset', component: messageset  }, //个人资料设置
                    { path: '/page/passwordset', component: passwordset  }, //个人资料设置
                    { path: '/page/immediatewithdrawal', component: immediatewithdrawal  }, //立即提现
                    { path: '/page/withdrawalsrecord', component: withdrawalsrecord  }, //提现记录
                    { path: '/page/messagedetail', component: messagedetail  }, //消息详情
                    { path: '/page/productdetail', component: productdetail  }, //产品详情
                    { path: '/page/product_ssdetail', component: product_ssdetail  }, //产品快照详情
                    { path: '/page/productpreorder', component: productpreorder  }, //产品预定
                    { path: '/page/oldproductpreorder', component: oldproductpreorder  }, //产品预定
                    { path: '/page/orderdetail', component: orderdetail  }, //订单详情
                    { path: '/page/orderdetaildisview', component: orderdetaildisview  }, //分销订单详情
                    { path: '/page/rollcodedetail', component: rollcodedetail  }, //券码详情
                    { path: '/page/mdisreg', component: mdisreg  }, //注册家游客
                    { path: '/page/browserprompt', component: browserprompt  }, //浏览器提示
                    { path: '/page/myset', component: myset  }, //设置
                    { path: '/page/mydisposter', component: mydisposter  }, //我的分销海报
                    { path: '/page/myclient', component: myclient  }, //我的客户
                    { path: '/page/myteam', component: myteam  }, //我的团队
                    { path: '/page/fun', component: fun  }, //玩赚
                    { path: '/page/regthirddissuccess', component: regthirddissuccess  }, //注册三级家游客成功页
                    { path: '/page/showtitle', component: showtitle  }, //分享信息页
                    { path: '/page/specialevent', component: specialevent  }, //专题活动
                    { path: '/page/nospecialevent', component: nospecialevent  }, //无专题活动
                    { path: '/page/fissionactivity', component: fissionactivity  }, //微信裂变活动
                    { path: '/page/fissionactivitysuccess', component: fissionactivitysuccess  }, //助力成功
                    { path: '/page/activitycompletion', component: activitycompletion  }, //完成情况
                    { path: '/page/activityends', component: activityends  }, //活动结束
                    { path: '/page/weeklynewproduct', component: weeklynewproduct  }, //每周新品
                    { path: '/page/mustpushtoday', component: mustpushtoday  }, //今日必推
                    { path: '/page/deliveryaddress', component: deliveryaddress  }, //收货地址
                    { path: '/page/deliveryaddressedit', component: deliveryaddressedit  }, //收货地址编辑
                    { path: '/page/deliveryaddressadd', component: deliveryaddressadd  }, //收货地址新增
                    { path: '/page/applyrefound', component: applyrefound  }, //申请退款
                    { path: '/page/viewlogistics', component: viewlogistics  }, //查看物流
                    { path: '/page/logisticlist', component: logisticlist  }, //多个包裹
                    { path: '/page/disorder', component: disorder  }, //分销订单+团队订单
                    { path: '/page/draw', component: draw  }, //抽奖
                    { path: '/page/coupon', component: coupon  },  //优惠券
                    { path:"/page/pickup",component:deliverygoods},//提货校验页
                    { path:"/page/pickup1",component:deliveryfinish},//提货结束页
                    { path:"/page/editdeliveryInfo",component:editdeliveryInfo},//螃蟹提货收货地址页面
                    { path:"/page/logistics",component:logistics},//螃蟹查询物流页
                    { path:"/page/logisticsdetail",component:logisticsdetail},//物流详情页面

                    { path:"/page/yearpurchases/pickup",component:yeardeliverygoods},//提货校验页
                    //{ path:"/page/yearpurchases/pickup",component:yeardeliveryfinish},//提货结束页
                    { path:"/page/yearpurchases/editdeliveryInfo",component:yeareditdeliveryInfo},//螃蟹提货收货地址页面
                    { path:"/page/yearpurchases/logistics",component:yearlogistics},//螃蟹查询物流页
                    { path:"/page/yearpurchases/logisticsdetail",component:yearlogisticsdetail},//物流详情页面

                    
                ]
            }

        ],
    })
    ////注册组件
import wviinput from '@/packages/input/index'
import wvitextarea from '@/packages/textarea/index'
import wvipicker from '@/packages/picker/index'
import wvichecklist from '@/packages/checklist/index'
import calendar from '@/packages/calendar/index'
import wvidatetimepicker from '@/packages/datetime-picker/index'
import gotop from '@/packages/gotop/index'
import { resolve } from 'path';
import showLoading from '@/packages/loading/showloading'
Vue.component('wvi-input', wviinput)
Vue.component('wvi-textarea', wvitextarea)
Vue.component('wvi-picker', wvipicker)
Vue.component('wvi-checklist', wvichecklist)
Vue.component('wvi-calendar', calendar)
Vue.component('wvi-date-time-picker', wvidatetimepicker)
Vue.component('wvi-gotop', gotop)
Vue.component('loading-gif', showLoading)



// WEBPACK FOOTER //
// ./src/router/index.js